export const JoinRacesIcon = props => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M8 5.5H9.5V4H8V5.5ZM11 5.5V4H12.5V5.5H11ZM8 11.5V10H9.5V11.5H8ZM14 8.5V7H15.5V8.5H14ZM14 11.5V10H15.5V11.5H14ZM11 11.5V10H12.5V11.5H11ZM14 5.5V4H15.5V5.5H14ZM9.5 7V5.5H11V7H9.5ZM5 16V4H6.5V5.5H8V7H6.5V8.5H8V10H6.5V16H5ZM12.5 10V8.5H14V10H12.5ZM9.5 10V8.5H11V10H9.5ZM8 8.5V7H9.5V8.5H8ZM11 8.5V7H12.5V8.5H11ZM12.5 7V5.5H14V7H12.5Z" />
    </svg>
  );
};

export const RaceWizardIcon = props => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15.8333 14.1667C16.25 13.1317 17.5 12.5 17.5 10C17.5 7.5 16.6667 2.5 10 2.5C3.33333 2.5 2.5 7.5 2.5 10C2.5 12.5 3.74583 13.1242 4.16667 14.1667L2.5 15L4.16667 17.5L6.17167 16.5442C7.21333 15.9492 7.65333 14.8108 7.17417 13.7417C6.27583 11.7358 5.83333 6.66667 10 6.66667C14.1667 6.66667 13.7242 11.7358 12.825 13.7417C12.3467 14.8117 12.7875 15.9492 13.8283 16.5442L15.8333 17.5L17.5 15L15.8333 14.1667Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
};

export const WatchIcon = props => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7 17V15H3.5C3.0875 15 2.73438 14.8531 2.44063 14.5592C2.14688 14.2653 2 13.9119 2 13.4992V4.49417C2 4.08139 2.14688 3.72917 2.44063 3.4375C2.73438 3.14583 3.0875 3 3.5 3H16.5C16.9125 3 17.2656 3.14694 17.5594 3.44083C17.8531 3.73472 18 4.08806 18 4.50083V13.5058C18 13.9186 17.8531 14.2708 17.5594 14.5625C17.2656 14.8542 16.9125 15 16.5 15H13V17H7ZM3.5 13.5H16.5V4.5H3.5V13.5Z"
        strokeWidth="0"
      />
    </svg>
  );
};

export const WatchlistIcon = props => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7.01113 14.5225L10.0013 12.7192L12.9915 14.5462L12.2083 11.1295L14.8425 8.85164L11.3777 8.54318L10.0013 5.31625L8.62487 8.51945L5.16007 8.82791L7.79427 11.1295L7.01113 14.5225ZM4.85156 17.4993L6.21161 11.6441L1.66797 7.70726L7.66279 7.18716L10.0013 1.66602L12.3398 7.18716L18.3346 7.70726L13.791 11.6441L15.151 17.4993L10.0013 14.3929L4.85156 17.4993Z"
        strokeWidth=".3"
      />
    </svg>
  );
};

export const MyRacesIcon = props => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M9.97885 17.0807C8.17441 17.0807 6.60177 16.4867 5.26094 15.2986C3.9201 14.1106 3.14823 12.6213 2.94531 10.8307H4.22094C4.43135 12.2699 5.07906 13.463 6.16406 14.4101C7.24892 15.3572 8.52052 15.8307 9.97885 15.8307C11.6039 15.8307 12.9823 15.2648 14.1143 14.1328C15.2462 13.0009 15.8122 11.6224 15.8122 9.9974C15.8122 8.3724 15.2462 6.99392 14.1143 5.86198C12.9823 4.73003 11.6039 4.16406 9.97885 4.16406C9.06858 4.16406 8.21552 4.36628 7.41969 4.77073C6.62372 5.17503 5.9383 5.73135 5.36344 6.43969H7.54302V7.68969H3.31219V3.45885H4.56219V5.43323C5.23844 4.63517 6.0483 4.0158 6.99177 3.5751C7.9351 3.13441 8.9308 2.91406 9.97885 2.91406C10.9618 2.91406 11.8827 3.09997 12.7418 3.47177C13.6007 3.84358 14.3495 4.34892 14.9884 4.98781C15.6273 5.6267 16.1327 6.37566 16.5045 7.23469C16.8763 8.09358 17.0622 9.01448 17.0622 9.9974C17.0622 10.9803 16.8763 11.9012 16.5045 12.7601C16.1327 13.6191 15.6273 14.3681 14.9884 15.007C14.3495 15.6459 13.6007 16.1512 12.7418 16.523C11.8827 16.8948 10.9618 17.0807 9.97885 17.0807ZM12.4805 13.3532L9.37802 10.2505V5.83073H10.6278V9.74427L13.3586 12.4749L12.4805 13.3532Z"
        strokeWidth=".3"
      />
    </svg>
  );
};

export const MarketIcon = props => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M3.5 17C3.0875 17 2.73438 16.8531 2.44063 16.5594C2.14688 16.2656 2 15.9125 2 15.5V4.5C2 4.0875 2.14688 3.73438 2.44063 3.44063C2.73438 3.14688 3.0875 3 3.5 3H16.5C16.9125 3 17.2656 3.14688 17.5594 3.44063C17.8531 3.73438 18 4.0875 18 4.5V15.5C18 15.9125 17.8531 16.2656 17.5594 16.5594C17.2656 16.8531 16.9125 17 16.5 17H3.5ZM3.5 15.5H16.5V4.5H3.5V15.5ZM5 13.5H15V12H5V13.5ZM5 10.5H8.5V6H5V10.5ZM10 10.5H15V9H10V10.5ZM10 7.5H15V6H10V7.5Z" />
    </svg>
  );
};

export const ChatIcon = props => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M3.75 16.25V5C3.75 4.65625 3.8724 4.36198 4.11719 4.11719C4.36198 3.8724 4.65625 3.75 5 3.75H15C15.3438 3.75 15.638 3.8724 15.8828 4.11719C16.1276 4.36198 16.25 4.65625 16.25 5V12.5C16.25 12.8438 16.1276 13.138 15.8828 13.3828C15.638 13.6276 15.3438 13.75 15 13.75H6.25L3.75 16.25ZM5.71875 12.5H15V5H5V13.2031L5.71875 12.5Z" />
    </svg>
  );
};

export const MovingUp = props => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M3.0625 14.6458L2 13.5833L6.08333 9.5C6.56944 9.01389 7.15972 8.77083 7.85417 8.77083C8.54861 8.77083 9.13889 9.01389 9.625 9.5L10.3333 10.2083C10.5278 10.4028 10.7639 10.5 11.0417 10.5C11.3194 10.5 11.5556 10.4028 11.75 10.2083L15.4375 6.5H13V5H18V10H16.5V7.5625L12.7917 11.25C12.3056 11.7361 11.7153 11.9792 11.0208 11.9792C10.3264 11.9792 9.73611 11.7361 9.25 11.25L8.5625 10.5625C8.36806 10.3681 8.13194 10.2708 7.85417 10.2708C7.57639 10.2708 7.34028 10.3681 7.14583 10.5625L3.0625 14.6458Z"
        fill="#10C083"
      />
    </svg>
  );
};

export const MovingDown = props => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M3.0625 5.35417L2 6.41667L6.08333 10.5C6.56944 10.9861 7.15972 11.2292 7.85417 11.2292C8.54861 11.2292 9.13889 10.9861 9.625 10.5L10.3333 9.79167C10.5278 9.59722 10.7639 9.5 11.0417 9.5C11.3194 9.5 11.5556 9.59722 11.75 9.79167L15.4375 13.5H13V15H18V10H16.5V12.4375L12.7917 8.75C12.3056 8.26389 11.7153 8.02083 11.0208 8.02083C10.3264 8.02083 9.73611 8.26389 9.25 8.75L8.5625 9.4375C8.36806 9.63194 8.13194 9.72917 7.85417 9.72917C7.57639 9.72917 7.34028 9.63194 7.14583 9.4375L3.0625 5.35417Z"
        fill="#FF3B30"
      />
    </svg>
  );
};

export const MovingNone = props => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M3.0625 14.6458L2 13.5833L6.08333 9.5C6.56944 9.01389 7.15972 8.77083 7.85417 8.77083C8.54861 8.77083 9.13889 9.01389 9.625 9.5L10.3333 10.2083C10.5278 10.4028 10.7639 10.5 11.0417 10.5C11.3194 10.5 11.5556 10.4028 11.75 10.2083L15.4375 6.5H13V5H18V10H16.5V7.5625L12.7917 11.25C12.3056 11.7361 11.7153 11.9792 11.0208 11.9792C10.3264 11.9792 9.73611 11.7361 9.25 11.25L8.5625 10.5625C8.36806 10.3681 8.13194 10.2708 7.85417 10.2708C7.57639 10.2708 7.34028 10.3681 7.14583 10.5625L3.0625 14.6458Z"
        fill="#10C083"
      />
    </svg>
  );
};

export const OpenInNew = props => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M4.5 17C4.0875 17 3.73437 16.8531 3.44062 16.5594C3.14687 16.2656 3 15.9125 3 15.5V4.5C3 4.0875 3.14687 3.73438 3.44062 3.44063C3.73437 3.14688 4.0875 3 4.5 3H10V4.5H4.5V15.5H15.5V10H17V15.5C17 15.9125 16.8531 16.2656 16.5594 16.5594C16.2656 16.8531 15.9125 17 15.5 17H4.5ZM8.0625 13L7 11.9375L14.4375 4.5H12V3H17V8H15.5V5.5625L8.0625 13Z"
        fill="#007AFF"
      />
    </svg>
  );
};
